export default "__VITE_ASSET__CWsNpvPD__"